<!-- 入仓 -->
<template>
  <el-container class="layout-container-demo" >
    <!-- 顶部工具栏 -->
      <el-header  class="flexItems">
        <div class="header-button" @click="closeBtnCLick">返回</div>
        <div class="flex goodsTabs">
            <span v-for="(item,index) in tabsMenu" class="tabsText" :key="index" @click="handleClick(index)" :class="{activeTabs:index===activeTab}" >{{item}}</span>
        </div>
        <el-select v-model="value" placeholder="请选择供应商" size="large" style="width: 21%"  class="supplierSelect" @change="selectSupplier($event,1)">
            <el-option v-for="item in options" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId" />
        </el-select>

        <el-icon @click="setClick" color="#fff" size="35" style="display: flex;justify-content: end;flex:1"><Tools /></el-icon>


      </el-header>
      <!-- 内容 -->
      <div class="flex" style="flex:1; ">
        <!-- 左侧菜单 -->
        <el-aside width="12%" style="height:calc(100vh - 310px)">
          <el-scrollbar style="height: 100%;">
            <el-menu :default-active="menuActive" active-text-color="#fff" @select="handleSelect">
              <el-menu-item :index="index+''" v-for="(item,index) in menuList" :key="index" class="menu-item">
                 {{item.label}}
              </el-menu-item>
            </el-menu>
          </el-scrollbar>
        </el-aside>
        <!-- 右侧内容 -->
        <el-main style="padding:10px 10px 0 ;flex:1;height:calc(100vh - 105px)" >
          <el-scrollbar style="height: 100%;" v-loading="loading">
            <div v-for="(item,index) in tableData" :key="index" >
                <h4 class="cont-title">{{item.supplierRcCode}}</h4>
                <div class="flex flexWrap">
                 <div class="entry-card-item" v-for="(v,i) in item.list" :key="i"  >
                    <el-card shadow="always" class="cont-card"  style="width:calc(100% - 30px)">
                    <div class="flex justifyBetween">
                        <div class="card-left">
                             <h3 class="card-title font-weight-bold">{{v.goodsName}}</h3>
                             <div class="font-weight-bold">{{ activeTab==0?GetNumByUnit(v.orderNo, "g", "kg"):v.unitOrderNo }}{{activeTab==0?'kg':v.unitName}}
                            <span style="font-size:12px" v-if="activeTab!=0">({{v.specFullName}})</span>
                            </div>
                        </div>
                         <el-image style="width: 120px; height: 80px" :src="v.goodsImg"  />
                    </div>
                    <div class="flexItems justifyBetween card-bottom">
                        <span class="font-weight-bold">单价：</span>
                        <el-input-number  v-if="v.scaleStatus==0"  v-model="v.kgUnitAddPrice" :precision="1" :step="0.1" :min="0.1"  style="flex:1;" />
                        <el-input :input-style="{textAlign:'center'}"  v-model="v.kgUnitAddPrice" v-else style="flex:1;" readonly  />
                        <span class="pirce-text">元/{{activeTab===0?'kg':v.unitName}}</span>
                        <!-- v-if="v.scaleStatus==0"  -->
                        <div class="entry-button" v-if="v.scaleStatus==0" @click="entryClick(v,index)">入仓</div>
                        <div class="font-weight-bold entry-text"  v-else>入仓:{{activeTab===0?GetNumByUnit(v.addWeight,'g','kg'):v.addNumber}}{{activeTab===0?'kg':v.unitName}}</div>
                    </div>
                </el-card>
                <div class="status-box" :class="{inactivestatus:v.scaleStatus!=0}"> {{v.scaleStatus!=0?'已入仓':'待入仓'}}</div>
             </div>
            </div>

          
            <!-- </div> -->
            </div>
            <el-empty description="暂无数据" v-if="tableData.length==0" />
          </el-scrollbar>
        </el-main>
      </div>
      <!-- 入仓弹框 -->
      <scale-dialog ref="scaleDialogRef" @onSubmit="submitEntry" />
      <!-- 设置弹框 -->
      <set-dialog ref="setDialogRef" />
  </el-container>
</template>
  
<script lang="ts" setup>
import { ref,getCurrentInstance, nextTick,onMounted} from "vue";
import { useRouter } from "vue-router";
import { Menu as IconMenu, Message, Setting } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import scaleDialog from "@/views/warehouse/scaleDialog.vue";
import setDialog from "@/views/warehouse/setDialog.vue";//setting弹框
import { warehouseScalelist, addscale,qrCode} from "@/api/addMaterial.js";
import { initScale } from "@/api/outMaterial.js";//偏离值初始化
//获取时间
import { parseTime } from "@/utils/time";
import { GetNumByUnit, toFixedDigit,accMul, accSub, accDiv } from "@/utils/uni.js";
// 字典
import { dict } from "@/utils/getDict.js";
import { ElLoading } from 'element-plus'
const { proxy } = getCurrentInstance();

const router = useRouter();
// 选项卡
const tabsMenu=ref(['称重商品','计件商品'])
// 当前选项卡下标
let activeTab=ref(0)
// 供应商
let value=ref('')
// 入仓数量
let num=ref()
// 弹框
const scaleDialogRef = ref();
// 供应商选项
const options = ref([])
// 入仓列表所有数据
const warehouseList=ref([])
// 入仓列表当前供应商数据
const tableData = ref([]);
// 采购人选项
const menuList = ref([]);
// 菜单选项下标
let menuActive=ref('0')

// 偏离值的范围值
const range=ref(0)
// 偏离值初始化开关 1为开启 0为关闭
const offsetState=ref(0)
let dictData=ref({})
const dictObj = ref({});
//获取字典值
const loading = ref(true)
// 设置弹框
const setDialogRef = ref(null);
  // 设置
  const setClick=() => {
    setDialogRef.value.open({},'0');
  }

// 字典初始化
const dictsFun = async () => {
  dictData.value =await dict(["all_unit_type","goods_type"], dictData.value);
  console.log(dictData.value,'dictData.value');
  
};
dictsFun();
// 商品选项点击
const handleClick = (index:number) => {
  activeTab.value=index
  tableData.value=[]

  selectSupplier()
}
// 菜单选项点击
const handleSelect = (index:string) => {
  menuActive.value=index+''
  tableData.value=[]

    selectSupplier()
}

// 秤端初始化
const initScaleList = async () => {
  try {
  const res = await initScale()
  range.value = res.data.offset;
  offsetState.value = res.data.offsetState;
  } catch (error) {
    
  }

}
initScaleList()



// 返回
const closeBtnCLick=() => {
  router.push("/");
}
// 入仓
const entryClick=(row:any,index:number)=> {
  if(row.kgUnitAddPrice<=0)return ElMessage.warning('请输入单价在进行入仓!!')
  let isWeight=activeTab.value===0?true:false
    scaleDialogRef.value.open(row,0,isWeight);
}

// 入仓列表
const getScaleList = async () => {  
  loading.value = true
// 当天时间
const date = new Date();
// 格式化时间
const dayTime = parseTime(date, "{y}-{m}-{d}");
// 请求参数
const params = {
    pageNum: 1,
    pageSize: 2000,
    params: {
      beginTime: dayTime + " 00:00:00",
      // beginTime: "2024-08-01 00:00:00",
      // endTime: '2024-09-15' + " 23:59:59",
      endTime: dayTime + " 23:59:59",
    },
    status: 0
}

 warehouseScalelist(params).then(res => {
  if(res.code===200){
    const data = res.rows;
    // 获取供应商选项 菜单选项 入仓列表
  let warehouseObj= entryDeconstruction(data)
  //   供应商列表
  const supplierList=warehouseObj.tabsList.filter((item,index)=>warehouseObj.tabsList.findIndex(o=>o.supplierId===item.supplierId)===index)
  //   领料人
  const menuLists=warehouseObj.menuLists.filter((item,index)=>warehouseObj.menuLists.findIndex(o=>o.id===item.id&&o.supplierId===item.supplierId)===index)
//   组合供应商及领料人菜单选项
  supplierList.forEach(item => {
    item.menuLists=menuLists.filter(o=>o.supplierId===item.supplierId)
  });
  options.value=supplierList
  
 //   所有入仓列表
  const list=[]
  warehouseObj.list.forEach((item:any,index:number)=>{
    const listIndex=list.findIndex(o=>o.purchaseUserId==item.purchaseUserId&&o.supplierId==item.supplierId&&o.supplierRcCode==item.supplierRcCode)
    item.unitName=item.unit?getDictLabel(item.unit,'all_unit_type',''):''

    if(listIndex==-1){
      list.push({purchaseUserId:item.purchaseUserId,supplierRcCode:item.supplierRcCode,purchaseUserName:item.purchaseUserName,supplierName:item.supplierName,supplierId:item.supplierId,olList:[item],list:[item]})
    }else{
        list[listIndex].list.push(item)
        list[listIndex].olList=list[listIndex].list
    }
  })
  console.log(list,'list');
  
  warehouseList.value=list
  value.value=supplierList[0].supplierId
  tableData.value=[]
  selectSupplier()
  }else{
    Message.error(res.msg)
  }
 }).catch(err => {
//    Message.error(err.message)
}).finally(()=>{
  loading.value = false
})

}
getScaleList()

// 入仓组装数据
const entryDeconstruction=(data:any=[],tabsList:any=[],menuLists:any=[],list:any=[],rank=0,parseItem:any)=>{
    data.forEach((item:any,index:number)=>{
        if(rank==0){
            tabsList.push({supplierName:item.supplierName,supplierId:item.supplierId})
        }else if(rank==1){
            menuLists.push({label:item.name,supplierId:parseItem.supplierId,id:item.id,value:item.id})
        }else{
            list.push(item)
        }
        if(item.list&&item.list.length>0){
            entryDeconstruction(item.list,tabsList,menuLists,list,rank+1,item)
        }
    })
    return {tabsList,menuLists,list}
}
// 选择供应商显示对应的入仓列表及领料人
const selectSupplier=(supplierId:any=value.value,type:number=0)=>{
    if(!!type){
        menuActive.value='0'
    }
    const supplierObj=options.value.find(item=>item.supplierId===supplierId)||{}
    menuList.value=supplierObj.menuLists
    const activeObj=menuList.value[menuActive.value]||{}
    const list=warehouseList.value.filter(item=>item.supplierId===supplierObj.supplierId&&item.purchaseUserId===activeObj.id)

    tableData.value=filterData(list)
}
// 过滤出计重或计件商品
const filterData=(data:any)=>{
    let weightData=['0','1','2','13','14']
    let list=data.map(v=>{
      v.list=v.olList.filter(item=>activeTab.value===0?weightData.includes(item.unit):!weightData.includes(item.unit))
      return v
      // if(activeTab.value===0)return v.list.filter(item=>weightData.includes(item.unit))
      // return v.list.filter(item=>!weightData.includes(item.unit))
    })
    
return list.filter(item=>item.list.length>0)
}
// 过滤出当前字典lable
const getDictLabel=(value:any,type:string,label:string)=>{
    const dictItem=dictData.value[type].find(item=>item.dictValue===value)
    return dictItem&&dictItem.dictLabel||''
}
// 提交入仓
const submitEntry = (row:any) => {
  const data=JSON.parse(JSON.stringify(row))
  // 转换单位 kg->g （实际重量）
  if(activeTab.value==0){ //计重
    data.addWeight = GetNumByUnit(data.weigth, "kg", "g");
  }else{
    data.addNumber = data.weigth;
  }
  // 是否直接入仓
  data.directReduceWarehouse=row.checked?row.checked:false
  // data.addWeight = activeTab.value==0?GetNumByUnit(data.addWeight, "kg", "g"):data.addWeight;
  const userId = localStorage.getItem("userId");
  data.signer=userId // 签收人
  delete data.weigth
// setTimeout(() => {

  // 判断是否启用偏离值
  if(offsetState.value===1){
    // 启用偏离值进行比较
    offsetCompare(data);
  }else{
    // 直接入仓
    confirmEntry(data);
  }

// },1000)
}

// 确认入仓
const confirmEntry = (data) => {
  ElMessageBox.alert('是否确认入库?','提示',{
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      showClose: false,
      showCancelButton:true,
      closeOnPressEscape:false,
      type: "warning",
      buttonSize: "large",
      cancelButtonClass: "cancel-button-class",
      customClass: "custom-class-text",
      confirmButtonClass: "confirm-button-class el-button--success",
  }).then(() => {
    data.scaleStatus = 1;
    data.goodsMode=activeTab.value

    addscale(data).then(res => {
      if (res.code === 200) {
        ElMessage.success(res.msg);
        getScaleList();
        // 开启监听
        script.startSerialPortListerning()
        print(data) // 打印标签
      } else {
        ElMessage.error(res.msg);
      }
    })
  }).catch(() => {
    console.log('cancel');
  });
}

// 启用偏离值进行比较
const offsetCompare = (data) => {
  // / 取偏离值的绝对值
   // 理论值
   let theoryVal=activeTab.value==0?data.orderNo:data.unitOrderNo
  // 实际值
  let actualVal=activeTab.value==0?data.addWeight:data.addNumber
  // theoryVal 理论重量
  const num = accSub(theoryVal, actualVal);
  
  const numbe = range.value * -1;
  if (num >= numbe && num <= range.value) {
    confirmEntry(data);
  } else {
    let message =
      num < range.value ? "多了！！！" : num > numbe ? "少了！！！" : "";
    proxy.$message.warning(message);
    // row.butLoad = false;
  }
}
let warehouseUrl = "";

// 获取二维码地址
const getQrCodeUrl = () => {
   qrCode().then(res => {
    warehouseUrl = res;
     console.log(res,'res');
  });
};
getQrCodeUrl()

// 打印入仓信息
const print = (row:any) => {
  const loading1 = ElLoading.service({
    lock: true,
    text: '正在入仓，请稍候......',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  const codeUrl = `${warehouseUrl}warehouseId=${row.warehouseId}&addInfoId=${row.addInfoId}`;
  const goodsType =  row.goodsType ? getDictLabel(row.goodsType ,'goods_type', '') : ''
  const day =
    row.guaranteeDays
      ? row.guaranteeDays + "天"
      : " ";

  // const dat = script.printPages(
  //   codeUrl || " ",
  //   row.goodsName || " ",
  //   goodsType || " ",
  //   parseTime(row.createTime, "{y}-{m}-{d}") || " ",
  //   parseTime(row.producedTime, "{y}-{m}-{d}") || " ",
  //   parseTime(row.guaranteePeriod, "{y}-{m}-{d}") || " ",
  //   day || " "
  // );
  const printdata = {
    codeUrl: codeUrl || " ",
    goodsName: row.goodsName || " ",
    goodsType: goodsType || " ",
    createTime: parseTime(row.createTime, "{y}-{m}-{d}") || " ",
    producedTime: parseTime(row.producedTime, "{y}-{m}-{d}") || " ",
    guaranteePeriod: parseTime(row.guaranteePeriod, "{y}-{m}-{d}") || " ",
    guaranteeDays: day || " "
  }
  script.printSample(JSON.stringify(printdata))
  // 停止监听
  script.stopSerialPortListerning()
  loading1.close()
};

</script>
  
  <style scoped>
  .layout-container-demo {
    font-size: 25px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
  }
.layout-container-demo .el-header {
  position: relative;
  /* background-color: var(--el-color-primary-light-7); */
  background-color:rgba(6, 172, 83, 1) ;
  color: var(--el-text-color-primary);
  height:65px
}
.layout-container-demo .el-aside {
  color: var(--el-text-color-primary);
  background: #fff;
}
.layout-container-demo .el-menu {
  border-right: none;
}
.layout-container-demo .el-main {
  padding: 0;
}
.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}
.header-button{
    display: inline-block;
    padding: 6px 15px; 
    color: #fff;
    border-radius: 5px;
    border: 1px solid #fff;
  cursor: pointer;

}
.goodsTabs{
    background:#fff ;
    color: #06AC53;
    padding: 2px;
    border-radius: 5px;
    margin-left: 40px;
  cursor: pointer;

}
.tabsText{
    padding: 5px 20px;
}
.activeTabs{
    color: #fff;
    background: #06AC53;
    border-radius: 5px;
    
}
.supplierSelect{
    width: 21%;
    margin-left: 20px;
}
>>>.supplierSelect .el-input{
    font-size: 25px;
    height: 44px;

}
>>>.supplierSelect .el-input__inner, .el-select-dropdown__item.selected{
    color: #06AC53;

}
.menu-item{
    border-bottom: 1px solid #eee;
    font-size: 22px;
}

.el-menu-item.is-active{
    background: #1cb563d6;
    /* color: #fff; */

}
.cont-title{
    border-bottom: 1px solid rgba(121, 121, 121, 1);
    width: 20%;
}
.cont-card{
    margin:10px 0;
    background: rgba(240, 255, 247, 1);
    border-color: rgba(3, 172, 84, 1);
    position: relative;

}
>>> .cont-card .el-card__body{
    padding:15px  10px 10px;
}
.card-title{
    color: #03AC54;
    margin-bottom: 10px;
}
.font-weight-bold{
    font-weight: bold;
}
.card-left{
    margin-left: 2px;
}
.card-bottom{
    font-size:18px ;
    margin-top: 10px;
    width: 100%;
}
.entry-button{
    color: #03AC54;
    border:1px solid rgba(3, 172, 84, 1);
    border-radius: 5px;
    padding: 4px 10px;
  cursor: pointer;

}
.entry-text{
    font-size:16px ;
}
.pirce-text{
    margin: 5px;
    font-size: 16px;
}
>>>.el-input-number__increase,>>> .el-input-number__decrease {
    border-radius: 50%;
}

>>> .card-bottom .el-input__wrapper{
    box-shadow: none;
    background: transparent;
}

>>> .card-bottom  .el-input__inner{
    background: #fff;
}
.entry-card-item{
    position: relative;
      width:calc(100% / 4);position:relative;margin-right:10px;
}
.status-box{
    font-size: 18px;
    background: #00c988;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    color: #fff;
    position: absolute;
    width: 29px;
    text-align: center;
    top: 50%;
    right: -0.5px;
    /* height: 125px; */
    transform: translateY(-50%);
    padding: 25px 0;
}
.inactivestatus{
    background: #d9dbe0;
}


/* 屏幕小于1280px */
@media screen and (max-width: 1280px) {
  .cont {
    width: 90%;
    margin: 0 auto;
  }
}
/*  屏幕小于1520或大于1280 */
@media screen and (max-width: 1520px) and (min-width: 1280px) {
  .cont {
    width: 90%;
    margin: 0 auto;
  }
}
/* 屏幕大于1520px */
@media screen and (min-width: 1520px) {
  .cont {
    width: 75%;
    margin: 0 auto;
  }
}
</style>
